






import {bus} from "@/main"
import {Component, Prop, Vue} from "vue-property-decorator"
import {AppraisalItem, getAppraisalTitlePath} from "@/data/repos/appraisal"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import {executeQuery} from "@/data/repos/query"
import ModalContainer from "@/components/dialogs/ModalContainer.vue"
import AppraisalRiskDrillDown2 from "@/components/widgets/appraisal/AppraisalRiskDrillDown2.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import config from "@/config"
import appConfig from "@/config"
import DataGridLink from "@/components/buttons/DataGridLink.vue"

function locationLinkCallback(entity: string) {
  return (fieldName: string, row: any): { url: string, text: string } => {
    return {
      url: `${config.IPR_BASE_URL}/pages/locationjumper.asp` +
        `?id=${encodeURIComponent(row[entity + "Id"])}`,
      text: row[entity + "Name"],
    }
  }
}

function appraisalLinkCallback(entity: string) {
  return (fieldName: string, row: any): { url: string, text: string } => {
    const locationId = row.roomId ? row.roomId :
      row.floorId ? row.floorId :
        row.buildingId ? row.buildingId : row.siteId
    const url = `${appConfig.IPR_BASE_URL}/pages/condition/conditionreport2.asp?` +
      `id=${encodeURIComponent(locationId)}` +
      `&surveyid=${encodeURIComponent(row.surveyId)}` +
      `&facetid=${encodeURIComponent(row.facetId)}` +
      `&highlight=${encodeURIComponent(row.subelementId)}`
    return {
      url,
      text: row[entity + "Name"],
    }
  }
}

@Component({
  components: {
    ModalContainer,
    DataGrid,
    AppraisalRiskDrillDown2,
  },
})
export default class AppraisalRiskDrillDown extends Vue {
  @Prop() public args!: { locationId: number, risk: AppraisalItem, riskId: number }
  private data: any[] | null = null
  public dataGridFields: any[] = [
    {name: "regionName", title: "Region", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: locationLinkCallback("region")},
    {name: "siteName", title: "Site", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: locationLinkCallback("site")},
    {name: "buildingName", title: "Building", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: locationLinkCallback("building")},
    {name: "floorName", title: "Floor", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: locationLinkCallback("floor")},
    {name: "roomName", title: "Room", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: locationLinkCallback("room")},
    {name: "surveyName", title: "Survey", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: appraisalLinkCallback("survey")},
    {name: "facetName", title: "Facet", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: appraisalLinkCallback("facet")},
    {name: "categoryName", title: "Category", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: appraisalLinkCallback("category")},
    {name: "elementName", title: "Major Element", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: appraisalLinkCallback("element")},
    {name: "subelementName", title: "Subelement", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: appraisalLinkCallback("subelement")},
    {name: "riskLabel", title: "Risk", dataType: DataType.Text, sort: 1},
    {name: "conditionRating", title: "Condition rating", dataType: DataType.Text, sort: 1},
    {name: "costtobsum", title: "Cost to B", dataType: DataType.Number, sort: 1},
  ]

  public get title() {
    return "Appraisal risk breakdown - " + getAppraisalTitlePath(this.args.risk)
  }

  public async getData(offset = 0, limit = 250): Promise<any[] | null> {
    // console.log("load data", JSON.stringify(risk, null, 1))
    const risk = this.args.risk
    const queryName = risk.subelementId ? "appraisal.risk.riskDrillDown_subelement" :
      risk.elementId ? "appraisal.risk.riskDrillDown_element" :
        risk.categoryId ? "appraisal.risk.riskDrillDown_category" :
          risk.facetId ? "appraisal.risk.riskDrillDown_facet" :
            risk.surveyId ? "appraisal.risk.riskDrillDown_survey" : null
    const args: any = risk.subelementId ? {subelementId: risk.subelementId} :
      risk.elementId ? {elementId: risk.elementId} :
        risk.categoryId ? {categoryId: risk.categoryId} :
          risk.facetId ? {facetId: risk.facetId} :
            risk.surveyId ? {surveyId: risk.surveyId} : null
    args.locationId = this.args.locationId
    args.riskId = this.args.riskId
    if (queryName) {
      return executeQuery("idr", queryName, args, this.filter, offset, limit)
    }
    return []
  }

  private filter(data: any[]): any[] {
    return data.map(item => {
      return {
        ...item,
        costtobsum: formatNumberWithGrouping(item.costtobsum, 2, 2),
      }
    })
  }

  public close() {
    bus.$emit("modalBoxDestroy")
  }

  public download() {
    const fileDownload = require('js-file-download')
    fileDownload(JSON.stringify(this.data), "appraisal-risk.json")
  }
}

